import "./clients.scss"
import React from "react"
import { Card, CardContent, CardHeader, Divider, Typography, Link, Box } from "@mui/material"
import { SeverityPill } from "../severity-pill"

export const ClientInformation = (props) => {
  const { client } = props

  const handleLinkClick = (e) => {
    e.preventDefault()
    let url = client.appUrl


    // Intentar agregar el protocolo si no existe
    if (!/^https?:\/\//i.test(url)) {
      url = "https://" + url
    }

    try {
      new URL(url)
      // Si la URL es válida, navegar
      window.open(url, "_blank", "noopener,noreferrer")
    } catch (error) {
      // Si la URL no es válida, redirigir a la página de Google
      window.open("https://www.google.com/search?q=site:" + encodeURIComponent(url), "_blank", "noopener,noreferrer")
    }
  }

  return (
    <Card
      sx={{
        border: "0.5px solid #dddddd",
        padding: "1px",
        boxShadow: "1px 1px #d5d5d5",
      }}
    >
      <CardHeader subheader="Datos del cliente" title="Cliente" sx={{ padding: 2 }} />
      <Divider />
      <CardContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            pb: 2,
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: "0.84rem",
                lineHeight: "1.5rem",
                fontWeight: "600",
                color: "primary.dark",
              }}
            >
              Nombre app
            </Typography>
            <Typography
              sx={{
                fontSize: "0.88rem",
                lineHeight: "1.1rem",
              }}
            >
              {client.appName}
            </Typography>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Typography
              sx={{
                fontSize: "0.84rem",
                lineHeight: "1.5rem",
                fontWeight: "600",
                color: "primary.dark",
              }}
            >
              Estado
            </Typography>
            <Typography
              sx={{
                fontSize: "0.88rem",
                lineHeight: "1.1rem",
              }}
            >
              <SeverityPill color={client.activo ? "success" : "error"}>
                {client.activo ? "Activo" : "Inactivo"}
              </SeverityPill>
            </Typography>
          </Box>
        </Box>
        <Box sx={{ pb: 2 }}>
          <Typography
            sx={{
              fontSize: "0.84rem",
              lineHeight: "1.5rem",
              fontWeight: "600",
              color: "primary.dark",
            }}
          >
            Url app
          </Typography>
          <Link
            component="button"
            variant="body2"
            onClick={handleLinkClick}
            sx={{
              fontSize: "0.88rem",
              lineHeight: "1.1rem",
              textAlign: "left",
              textDecoration: "none",
            }}
          >
            {client.appUrl}
          </Link>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            pb: 2,
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: "0.84rem",
                lineHeight: "1.5rem",
                fontWeight: "600",
                color: "primary.dark",
              }}
            >
              Razón social
            </Typography>
            <Typography
              sx={{
                fontSize: "0.88rem",
                lineHeight: "1.1rem",
              }}
            >
              {client.razonSocial}
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: "0.84rem",
                lineHeight: "1.5rem",
                fontWeight: "600",
                color: "primary.dark",
              }}
            >
              {!client.personaFisica ? "CUIT" : client.tipoDoc}
            </Typography>
            <Typography
              sx={{
                fontSize: "0.88rem",
                lineHeight: "1.1rem",
              }}
            >
              {client.tipoDoc === "CUIT" ? client.cuit : client.nroDoc}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}